import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { IconsModule } from '@core/icons/icons.module';
import { TranslocoCoreModule } from '@core/transloco/transloco.module';
import { ImageModule } from './components/image/image.module';
import { PaginationModule } from './components/pagination/pagination.module';
import { RequiredRolesModule } from './directives/required-roles/required-roles.module';
import { SwiperModule } from './directives/swiper/swiper.module';
import { ApiModule } from './services/api/api.module';
import { GraphqlModule } from './services/graphql/graphql.module';
import { SeoInterceptor } from './services/seo/seo.interceptor';

/**
 * Migrate Modules TranslocoCoreModule, IconsModule to Targx Core
 */

@NgModule({
  imports: [
    CommonModule,
    GraphqlModule,
    ApiModule,
    TranslocoCoreModule,
    IconsModule,
    RequiredRolesModule,
    SwiperModule,
    ImageModule,
    PaginationModule,
  ],
  exports: [
    GraphqlModule,
    ApiModule,
    RequiredRolesModule,
    SwiperModule,
    ImageModule,
    PaginationModule,
  ],
  declarations: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SeoInterceptor,
      multi: true,
    },
  ],
})
export class TargxModule {
  /**
   * Constructor
   *
   * @param parentModule
   */
  constructor(@Optional() @SkipSelf() parentModule?: TargxModule) {
    if (parentModule) {
      throw new Error(
        'TargxModule has already been loaded. Import this module in the AppModule only!',
      );
    }
  }
}
